import { createSlice } from "@reduxjs/toolkit";
import { fetchPurchaseReturnGSTR2 } from "./PurchaseReturnGSTR2Thunk";

const initialState = {
  data: [],
  loading: false,
  error: null,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const slice = createSlice({
  name: "purchaseReturnGSTR2",
  initialState,

  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetData: (state) => {
      state.data = [];
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchPurchaseReturnGSTR2.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPurchaseReturnGSTR2.fulfilled, (state, action) => {
        state.loading = false;
        state.data = Array.isArray(action.payload)
          ? action.payload
          : [];
      })
      .addCase(fetchPurchaseReturnGSTR2.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { setFilters, resetData } = slice.actions;
export default slice.reducer;